module.exports = __webpack_public_path__ + "static/media/Шаг 2.129c8637.png";